import React, { memo } from 'react';
import { Image } from 'pcln-design-system';
import { trimAssetUrl } from '../utils';
/** @public */
const ContentfulImage = ({
  altText,
  asset,
  className,
  desktopFocalPoint,
  fit,
  format = 'webp',
  height,
  quality = 80,
  radius,
  width,
  ...rest
}) => {
  const assetAltText = asset?.description || asset?.title;
  const file = asset?.file;
  const url = trimAssetUrl(file?.url);
  const dimensions = file?.details?.image || {};
  const h = height || dimensions.height;
  const w = width || dimensions.width;
  const heightPixels = h ? `${h}px` : null;
  const widthPixels = w ? `${w}px` : null;
  if (!url) return null;
  const imageParams = {
    ...(fit && {
      fit
    }),
    ...(desktopFocalPoint && {
      f: desktopFocalPoint
    }),
    ...(!url.includes('.svg') && {
      fm: format
    }),
    ...(radius && {
      r: radius
    }),
    ...(width && {
      w: width
    }),
    ...(height && {
      h: height
    }),
    q: quality
  };
  const imageParamsKeys = Object.keys(imageParams);
  const imageParamString = `?${imageParamsKeys.map(key => `${key}=${imageParams[key]}`).join('&')}`;
  const src = `https:${url}${imageParamString}`;
  return React.createElement(Image, {
    src: src,
    alt: altText || assetAltText,
    height: heightPixels,
    width: widthPixels,
    className: className,
    ...rest
  });
};
export default memo(ContentfulImage);